import React, { useState } from 'react'

import { MarbleRating } from './MarbleRating'

import './SmallMarbleRating.less'
import { Marble, marbleColorForRating } from './Marble'

interface IProps {
  children?: any
  rating: number
  numberRated?: number
}

export const SmallMarbleRating = (props: IProps) => {
  const [hovered, setHovered] = useState(false)
  const { rating, numberRated, children } = props
  const roundedRating = Math.round(rating)

  return (
    <div
      className="SmallMarbleRating"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {hovered && children}
      <MarbleRating
        readonly={true}
        initialRating={roundedRating}
        fullSymbol={<Marble color={marbleColorForRating(roundedRating)} />}
      />
      {numberRated && (
        <span className="SmallMarbleRating__ratingCount">({numberRated})</span>
      )}
    </div>
  )
}
